/*
  bp-configurator.js — Lógica del configurador BeetlePrint para Shopify.
  v2 (editor premium): añade DRAG real del logo (ratón + dedo) sincronizado
  con los sliders, formas de zona segura (rect / cuadrada / circular),
  "value bubbles" de feedback inmediato y centrar/reset con animación suave.

  Sin frameworks. Lee window.BP_DATA[sectionId] y enlaza con data-bp-bind.
  Toda la apariencia sigue controlada por variables --bp-* (NO tocar aquí).

  Cambios vs v1 (todo lo demás es idéntico):
    · clamp()                → utilidad nueva.
    · effSafe()              → zona segura efectiva según la forma.
    · applySafeZone()        → aplica clase de forma + estilo fino.
    · applyDecal()           → usa effSafe() y marca el logo como arrastrable.
    · syncDecalInputs()      → además refresca las "bubbles" de valor.
    · setupBubbles()         → crea las bubbles de cada slider.
    · setupDrag()            → drag pointer/touch del logo, clamp y sync.
    · animateDecal()         → transición suave para centrar / reset.

  3D: el visor <model-viewer> sigue intacto. El drag solo captura el logo;
  el resto del canvas sigue rotando el modelo 3D (overlay con pointer-events
  none salvo en el propio logo). Fase 2 (decal real 3D) sin cambios: hookDecal3D.
*/
(function () {
  "use strict";

  // ===================================================================
  //  [PARCHE 1] Núcleo por tipo — SOLO DATOS. Aún NO se usa en ningún
  //  sitio (código muerto intencional). No cambia comportamiento.
  // ===================================================================
  var BP_TYPES = {
    //               engine  viewer3d  safeZone  silhouette  hole   openClose  ai
    logo_shape:     { engine: "2d", viewer3d: false, safeZone: false, silhouette: true,  hole: true,  openClose: false, ai: true },
    surface_flat:   { engine: "2d", viewer3d: false, safeZone: true,  silhouette: false, hole: false, openClose: false, ai: true },
    surface_3d:     { engine: "3d", viewer3d: true,  safeZone: true,  silhouette: false, hole: false, openClose: false, ai: true },
    articulated_3d: { engine: "3d", viewer3d: true,  safeZone: true,  silhouette: false, hole: false, openClose: true,  ai: true }
  };

  // Fallback retrocompatible: producto sin type → comportamiento de hoy.
  function resolveType(p) {
    if (p && p.type && BP_TYPES[p.type]) return p.type;
    return (p && p.enable3D && p.model3dUrl) ? "surface_3d" : "surface_flat";
  }
  function capsOf(p) { return BP_TYPES[resolveType(p)]; }

  function pricing(p, qty) {
    var qs = (p.quantities || []).map(Number).sort(function (a, b) { return a - b; });
    var low = qs[0] || qty;
    var high = qs[qs.length - 1] || qty;
    var ratio = high > low ? Math.log(qty / low) / Math.log(high / low) : 1;
    var unit = Math.max(p.unitHigh, p.unitLow + (p.unitHigh - p.unitLow) * Math.min(1, Math.max(0, ratio)));
    return { unit: unit, total: unit * qty };
  }

  function fmt(n) { return n.toFixed(2) + " €"; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clamp(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function defaultDecal() {
    return { scale: 1.0, x: 0, y: 0, rotation: 0, opacity: 1.0 };
  }

  // Etiqueta legible para las "bubbles" de cada slider.
  function fmtDecal(key, v) {
    if (isNaN(v)) v = 0;
    if (key === "scale") return "×" + v.toFixed(1);
    if (key === "rotation") return Math.round(v) + "°";
    if (key === "opacity") return Math.round(v * 100) + "%";
    return (v > 0 ? "+" : "") + Math.round(v); // x / y
  }

  function initSection(sectionEl) {
    var sectionId = sectionEl.id.replace(/^bp-/, "");
    var data = (window.BP_DATA || {})[sectionId];
    if (!data || !data.products || !data.products.length) return;

    var firstProduct = data.products[0];
    var state = {
      product: firstProduct,
      // [PARCHE 2] type y caps derivados al iniciar. Aún NO se leen en
      // render, setupViewer ni applySafeZone. Solo viven en el state.
      type: resolveType(firstProduct),
      caps: capsOf(firstProduct),
      quantity: firstProduct.moq,
      finish: (firstProduct.finishes && firstProduct.finishes[0]) || "Vinilo",
      designUrl: null,
      designFile: null,
      attachMetafield: data.saveToMetafield !== false,
      decal: defaultDecal(),
      decalMode: "2d"
    };

    var canvas = $("#bp-canvas-" + sectionId);
    var binds = {};
    $$("[data-bp-bind]", sectionEl).forEach(function (el) {
      var key = el.getAttribute("data-bp-bind");
      binds[key] = binds[key] || [];
      binds[key].push(el);
    });

    // Zona segura efectiva según la forma (circular/cuadrada → alto = ancho,
    // que sobre un canvas cuadrado da un círculo/cuadrado perfecto).
    function effSafe() {
      var sz = state.product.safeZone || { top: 30, left: 30, width: 40, height: 40 };
      var shape = sz.shape || "rect";
      var w = sz.width, h = sz.height;
      if (shape === "circle" || shape === "square") h = w;
      return { top: sz.top, left: sz.left, width: w, height: h, shape: shape };
    }

    // --- 3D viewer ---------------------------------------------------------
    function setupViewer() {
      // [PARCHE 9] respetar capacidad 3D del tipo: si viewer3d=false, nunca
      // hay 3D (ni se carga model3dUrl); se usa la imagen fallback como hasta ahora.
      var has3D = state.caps.viewer3d && !!(state.product.model3dUrl && state.product.enable3D);
      var mv = binds["model-viewer"] && binds["model-viewer"][0];
      if (mv) {
        if (has3D) {
          if (mv.getAttribute("src") !== state.product.model3dUrl) {
            mv.setAttribute("src", state.product.model3dUrl);
          }
          if (state.product.autoRotate) mv.setAttribute("auto-rotate", "");
          else mv.removeAttribute("auto-rotate");
          mv.style.display = "block";
        } else {
          mv.removeAttribute("src");
          mv.style.display = "none";
        }
      }
      if (binds["product-image"]) {
        binds["product-image"].forEach(function (img) {
          // [PARCHE 10a] en logo_shape el logo es el protagonista: sin imagen base.
          if (has3D || state.type === "logo_shape") { img.style.display = "none"; return; }
          if (state.product.image) {
            img.src = state.product.image;
            img.alt = state.product.name;
            img.style.display = "block";
          } else {
            img.removeAttribute("src");
            img.style.display = "none";
          }
        });
      }
    }

    function applySafeZone() {
      var els = binds["safe-zone"];
      if (!els || !data.showSafeZone) return;
      // [PARCHE 6] respetar capacidad del tipo: si no usa safe zone, ocultarla.
      if (!state.caps.safeZone) { els.forEach(function (el) { el.style.display = "none"; }); return; }
      var sz = state.product.safeZone;
      els.forEach(function (el) {
        el.style.top = sz.top + "%";
        el.style.left = sz.left + "%";
        el.style.width = sz.width + "%";
        el.style.height = sz.height + "%";
        el.style.display = "block";
        el.classList.remove("bp-safe--rect", "bp-safe--square", "bp-safe--circle");
        el.classList.add("bp-safe--" + sz.shape);
      });
    }

    // --- Decal del diseño (Fase 1: overlay HTML) ---------------------------
    function applyDecal() {
      var layer = binds["decal-overlay"] && binds["decal-overlay"][0];
      var img = binds["decal-img"] && binds["decal-img"][0];
      var controls = binds["decal-controls"] && binds["decal-controls"][0];
      if (!layer || !img) return;

      if (!state.designUrl) {
        layer.style.display = "none";
        if (controls) controls.style.display = "none";
        img.classList.remove("is-draggable");
        return;
      }

      layer.style.display = "block";
      if (controls) controls.style.display = "block";
      img.classList.add("is-draggable"); // habilita el arrastre del logo

      var sz = state.product.safeZone;
      // [PARCHE 10b] Logo Shape Engine v0: en logo_shape el logo va centrado
      // en el canvas (50/50) y con escala base mayor (protagonista). Sin IA,
      // sin borde, sin agujero, sin quitar fondo. Otros tipos: idéntico a antes.
      var isLogo = (state.type === "logo_shape");
      var baseW = isLogo ? 70 : sz.width;
      var cx = (isLogo ? 50 : sz.left + sz.width / 2) + state.decal.x;
      var cy = (isLogo ? 50 : sz.top + sz.height / 2) + state.decal.y;

      img.src = state.designUrl;
      img.style.left = cx + "%";
      img.style.top = cy + "%";
      img.style.width = (baseW * state.decal.scale) + "%";
      img.style.transform = "translate(-50%, -50%) rotate(" + state.decal.rotation + "deg)";
      img.style.opacity = state.decal.opacity;

      // [PARCHE 12] Anilla vinculada al logo (SOLO logo_shape). Se ancla al
      // borde superior REAL del diseño (medido), se mueve con X/Y y escala con él.
      var ring = layer.querySelector(".bp-logo-ring");
      if (state.type === "logo_shape") {
        if (!ring) { ring = document.createElement("div"); ring.className = "bp-logo-ring"; layer.appendChild(ring); }
        img.onload = applyDecal; // re-medir cuando la imagen ya tiene tamaño real
        var lr = layer.getBoundingClientRect();
        var ir = img.getBoundingClientRect();
        if (lr.width && lr.height && ir.height) {
          ring.style.display = "block";
          ring.style.left  = ((ir.left - lr.left + ir.width / 2) / lr.width * 100) + "%"; // centro X del logo
          ring.style.top   = ((ir.top  - lr.top) / lr.height * 100) + "%";                 // borde superior del logo
          ring.style.width = ((ir.width / lr.width) * 100 * 0.18) + "%";                    // diámetro ∝ ancho del logo
        }
      } else if (ring) {
        ring.style.display = "none";
      }

      hookDecal3D();
    }

    /* FASE 2 HOOK — proyección real sobre el .glb (sin cambios). */
    function hookDecal3D() {
      if (state.decalMode !== "3d-decal") return;
      if (typeof window.BP3D !== "object" || !window.BP3D.applyDecal) return;
      try {
        window.BP3D.applyDecal({
          sectionId: sectionId,
          product: state.product,
          textureUrl: state.designUrl,
          decal: state.decal
        });
      } catch (err) {
        console.warn("[BeetlePrint] BP3D.applyDecal error:", err);
      }
    }

    function render() {
      // [PARCHE 4] reflejar el tipo en el DOM (solo atributo). Sin efecto
      // visual: ninguna regla CSS lo usa todavía. Se mantiene coherente en
      // cada render (init y cambio de producto). Único uso = setAttribute.
      sectionEl.setAttribute("data-bp-type", state.type);
      // [PARCHE 5] reflejar capacidades en el DOM (solo atributos, ninguna
      // regla CSS las usa todavía). 4 setAttribute, sin efecto visual.
      sectionEl.setAttribute("data-bp-cap-3d", state.caps.viewer3d ? "1" : "0");
      sectionEl.setAttribute("data-bp-cap-safe", state.caps.safeZone ? "1" : "0");
      sectionEl.setAttribute("data-bp-cap-silhouette", state.caps.silhouette ? "1" : "0");
      sectionEl.setAttribute("data-bp-cap-openclose", state.caps.openClose ? "1" : "0");
      setupViewer();
      applySafeZone();

      // cantidades
      var qg = binds["qty-grid"] && binds["qty-grid"][0];
      if (qg) {
        qg.innerHTML = "";
        (state.product.quantities || []).map(Number).forEach(function (q) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "bp-qty";
          b.setAttribute("data-active", q === state.quantity);
          b.innerHTML = "<strong>" + q + "</strong><small>" + data.t.units + "</small>";
          b.onclick = function () { state.quantity = q; render(); };
          qg.appendChild(b);
        });
      }
      // finishes
      var fg = binds["finish-grid"] && binds["finish-grid"][0];
      if (fg) {
        fg.innerHTML = "";
        (state.product.finishes || []).forEach(function (f) {
          var name = (typeof f === "string") ? f.trim() : f;
          if (!name) return;
          var b = document.createElement("button");
          b.type = "button";
          b.className = "bp-finish";
          b.textContent = name;
          b.setAttribute("data-active", name === state.finish);
          b.onclick = function () { state.finish = name; render(); };
          fg.appendChild(b);
        });
      }
      // summary
      if (binds["summary-name"]) binds["summary-name"].forEach(function (e) { e.textContent = state.product.name; });
      var pr = pricing(state.product, state.quantity);
      if (binds["unit-price"]) binds["unit-price"].forEach(function (e) { e.textContent = fmt(pr.unit); });
      if (binds["total-price"]) binds["total-price"].forEach(function (e) { e.textContent = fmt(pr.total); });
      if (binds["summary-rows"]) {
        binds["summary-rows"].forEach(function (e) {
          e.innerHTML =
            '<div class="bp-row"><span>' + data.t.units + '</span><strong>' + state.quantity + '</strong></div>' +
            '<div class="bp-row"><span>' + (data.t.finish || 'Acabado') + '</span><strong>' + state.finish + '</strong></div>' +
            '<div class="bp-row"><span>' + data.t.productionTime + '</span><strong>' + (state.product.productionTime || '-') + '</strong></div>';
        });
      }

      applyDecal();
    }

    // --- Selector de producto ---------------------------------------------
    $$("[data-bp-product]", sectionEl).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var h = btn.getAttribute("data-bp-product");
        var p = data.products.find(function (x) { return x.handle === h; });
        if (!p) return;
        state.product = p;
        // [PARCHE 3] mantener type/caps coherentes al cambiar producto.
        // Aún NO se usan en render, setupViewer ni applySafeZone.
        state.type = resolveType(p);
        state.caps = capsOf(p);
        state.quantity = p.moq;
        state.finish = (p.finishes && p.finishes[0]) || state.finish;
        render();
      });
    });

    // --- Upload de diseño (FileReader → blob URL) -------------------------
    function handleFile(f) {
      if (!f) return;
      if (state.designUrl && state.designUrl.indexOf("blob:") === 0) {
        try { URL.revokeObjectURL(state.designUrl); } catch (e) {}
      }
      state.designFile = f;
      state.designUrl = URL.createObjectURL(f);
      // Al subir, arranca centrado y a escala 1 para que "ya se vea perfecto".
      state.decal = defaultDecal();
      syncDecalInputs();
      applyDecal();
    }
    var uploadInput = binds["upload-input"] && binds["upload-input"][0];
    var uploadZone = binds["upload-zone"] && binds["upload-zone"][0];
    if (uploadInput) {
      uploadInput.addEventListener("change", function (e) {
        handleFile(e.target.files && e.target.files[0]);
      });
    }
    if (uploadZone) {
      ["dragenter", "dragover"].forEach(function (ev) {
        uploadZone.addEventListener(ev, function (e) {
          e.preventDefault(); uploadZone.classList.add("is-dragging");
        });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        uploadZone.addEventListener(ev, function (e) {
          e.preventDefault(); uploadZone.classList.remove("is-dragging");
        });
      });
      uploadZone.addEventListener("drop", function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        handleFile(f);
      });
    }

    // --- Sliders, bubbles, centrar, reset ----------------------------------
    function syncDecalInputs() {
      $$("[data-bp-decal]", sectionEl).forEach(function (inp) {
        var k = inp.getAttribute("data-bp-decal");
        if (k in state.decal) {
          inp.value = state.decal[k];
          if (inp._bubble) inp._bubble.textContent = fmtDecal(k, state.decal[k]);
        }
      });
    }

    // Crea una "bubble" de valor a la derecha de cada slider.
    function setupBubbles() {
      $$("[data-bp-decal]", sectionEl).forEach(function (inp) {
        if (inp._bubble) return;
        var b = document.createElement("span");
        b.className = "bp-decal-value";
        inp.insertAdjacentElement("afterend", b);
        inp._bubble = b;
        var k = inp.getAttribute("data-bp-decal");
        b.textContent = fmtDecal(k, parseFloat(inp.value));
      });
    }

    $$("[data-bp-decal]", sectionEl).forEach(function (input) {
      var key = input.getAttribute("data-bp-decal");
      input.addEventListener("input", function () {
        var v = parseFloat(input.value);
        if (!isNaN(v)) {
          state.decal[key] = v;
          if (input._bubble) input._bubble.textContent = fmtDecal(key, v);
          applyDecal();
        }
      });
    });

    // Animación suave puntual (centrar / reset) sin afectar al drag.
    function animateDecal() {
      var img = binds["decal-img"] && binds["decal-img"][0];
      if (!img) return;
      img.classList.add("is-animating");
      window.setTimeout(function () { img.classList.remove("is-animating"); }, 380);
    }

    var centerBtn = binds["decal-center"] && binds["decal-center"][0];
    if (centerBtn) {
      centerBtn.addEventListener("click", function () {
        animateDecal();
        state.decal.x = 0;   // centra exactamente en el centro de la zona segura
        state.decal.y = 0;
        syncDecalInputs();
        applyDecal();
      });
    }
    var resetBtn = binds["decal-reset"] && binds["decal-reset"][0];
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        animateDecal();
        state.decal = defaultDecal(); // escala 1, centrado, sin rotación, opaco
        syncDecalInputs();
        applyDecal();
      });
    }

    // --- DRAG real del logo (ratón + dedo) sincronizado con sliders --------
    function setupDrag() {
      var img = binds["decal-img"] && binds["decal-img"][0];
      if (!img || !canvas) return;
      var dragging = false, startX = 0, startY = 0, startDX = 0, startDY = 0, rect = null;

      img.addEventListener("pointerdown", function (e) {
        if (!state.designUrl) return;
        dragging = true;
        rect = canvas.getBoundingClientRect();
        startX = e.clientX; startY = e.clientY;
        startDX = state.decal.x; startDY = state.decal.y;
        img.classList.remove("is-animating");
        img.classList.add("is-dragging");
        try { img.setPointerCapture(e.pointerId); } catch (_) {}
        e.preventDefault();
      });

      img.addEventListener("pointermove", function (e) {
        if (!dragging || !rect) return;
        var dxPct = (e.clientX - startX) / rect.width * 100;
        var dyPct = (e.clientY - startY) / rect.height * 100;
        // Rango de los sliders X/Y: -50..50 (% del canvas).
        state.decal.x = clamp(startDX + dxPct, -50, 50);
        state.decal.y = clamp(startDY + dyPct, -50, 50);
        syncDecalInputs();
        applyDecal();
        e.preventDefault();
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        img.classList.remove("is-dragging");
        try { img.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      img.addEventListener("pointerup", endDrag);
      img.addEventListener("pointercancel", endDrag);
      img.addEventListener("lostpointercapture", endDrag);
    }

    // --- Metafield toggle --------------------------------------------------
    var metaToggle = binds["metafield-toggle"] && binds["metafield-toggle"][0];
    if (metaToggle) {
      metaToggle.addEventListener("change", function () { state.attachMetafield = metaToggle.checked; });
    }

    // --- Add to cart -> AJAX Cart API de Shopify --------------------------
    if (binds["add-to-cart"]) {
      binds["add-to-cart"].forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (!state.product.shopifyVariantId) {
            console.warn("[BeetlePrint] Configura el Shopify Variant ID en los settings del producto.");
            window.alert("⚠ Configura Variant ID en el editor de tema.");
            return;
          }
          var pr = pricing(state.product, state.quantity);
          var properties = {
            _bp_finish: state.finish,
            _bp_unit_price: pr.unit.toFixed(2),
            _bp_total_price: pr.total.toFixed(2),
            _bp_design_file_name: (state.designFile && state.designFile.name) || "",
            _bp_decal_scale: state.decal.scale.toFixed(2),
            _bp_decal_x: state.decal.x.toFixed(0),
            _bp_decal_y: state.decal.y.toFixed(0),
            _bp_decal_rotation: state.decal.rotation.toFixed(0),
            _bp_decal_opacity: state.decal.opacity.toFixed(2)
          };
          var formData = new FormData();
          formData.append("id", state.product.shopifyVariantId);
          formData.append("quantity", state.quantity);
          Object.keys(properties).forEach(function (k) {
            formData.append("properties[" + k + "]", properties[k]);
          });
          if (state.attachMetafield && state.designFile) {
            formData.append("properties[Design file]", state.designFile, state.designFile.name);
          }
          fetch("/cart/add.js", { method: "POST", body: formData })
            .then(function (r) { return r.json(); })
            .then(function () { window.location.href = "/cart"; })
            .catch(function (e) { console.error("[BeetlePrint] cart/add error", e); });
        });
      });
    }

    // Inicialización de los extras del editor v2.
    setupBubbles();
    setupDrag();

    render();
  }

  function bootAll() { $$(".bp-section").forEach(initSection); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  // Shopify Theme Editor: re-init al cargar/recargar la sección
  document.addEventListener("shopify:section:load", function (e) {
    var el = document.getElementById(e.target.id);
    if (el && el.classList.contains("bp-section")) initSection(el);
  });
})();

